import React from 'react';
import './ErrorState.css';

interface ErrorStateProps {
  message: string;
  onRetry: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => (
  <div className="dashboard-error-state">
    <p className="dashboard-error-state-text">{message}</p>
    <button className="dashboard-error-state-retry" onClick={onRetry}>Retry</button>
  </div>
);

export default ErrorState;
